import { removeAllTagsFromMarkdown } from '../../../utils/markdown';
import { filterUndefinedAndEmptyValues, gtmEvent } from '../../../utils/gtmEvents';
export const gtmEditBuild = ({ linkText, linkUrl, componentType, model, trim, gtmBodyStyle, inventoryStatus, }) => {
    const gtmPayload = {
        availability_flag: inventoryStatus,
        body_style: gtmBodyStyle,
        trim: removeAllTagsFromMarkdown(trim),
        model,
        component_type: componentType,
        link_url: linkUrl,
        link_Text: linkText,
        cta_placement: 'summary',
        cta_type: 'build',
        event: 'cta_click',
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export const gtmExpandAccordionItem = ({ linkText, componentType, model, trim, gtmBodyStyle, inventoryStatus, }) => {
    const gtmPayload = {
        availability_flag: inventoryStatus,
        body_style: gtmBodyStyle,
        trim: removeAllTagsFromMarkdown(trim),
        model,
        component_type: componentType,
        link_text: linkText,
        cta_placement: 'summary',
        cta_type: 'my selections',
        event: 'cta_click',
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export const gtmEditAcccessory = ({ linkText, linkUrl, componentType, model, trim, gtmBodyStyle, inventoryStatus, }) => {
    const gtmPayload = {
        availability_flag: inventoryStatus,
        body_style: gtmBodyStyle,
        trim: removeAllTagsFromMarkdown(trim),
        model,
        component_type: componentType,
        link_url: linkUrl,
        link_text: linkText,
        cta_placement: 'summary',
        cta_type: 'my selections',
        event: 'cta_click',
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
